'use strict';

// Import Libraries
import React from 'react';
// Import JS Modules
import classNames from 'classnames';
import { calculateDimensions } from '../_utils/tools/image-tools';
// Import JSX Modules
import Spinner from '../_utils/spinner';

// -----------------------------------------------------------
//  MetallicCardProductImage
// -----------------------------------------------------------
class MetallicCardProductImage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false
    };
  }

  componentDidMount() {
    this.updateImageDimensions();
  }

  render() {
    if (!this.state.loaded) {
      return <Spinner />;
    }

    const { width, height } = this.state;
    let portraitClassName;

    if (height > width && height > 640) {
      portraitClassName = 'contain-portrait-height';
    } else if (height > width) {
      portraitClassName = 'contain-portrait';
    }

    return (
      <div className="product-image-selected shadowing-for-cards metallic-card">
        <img src={ this.props.url } className={ classNames('img-fluid mx-auto product-image', portraitClassName) } />
      </div>
    );
  }

  updateImageDimensions() {
    calculateDimensions(this.props.url).then(({ height, width }) => {
      this.setState({
        height,
        width,
        loaded: true
      });
    }).catch(() => {
      this.setState({
        loaded: false
      });
    });
  }
}

export default MetallicCardProductImage;
